import { UseFirstRender, UseIntermitence } from '@/hooks';
import { useAuth } from '@/hooks/authContext';
import {
  actualStory,
  changeBackground,
  closePublishModal,
  getCollaboratorStory,
  getTemplate,
  getUserPurchases,
  hideGradient,
  inviteAccepted,
  openModal,
  openSubscriptionPopup,
  refreshUserData,
  setCode,
  setCreateMemoryStep,
  setPendingInvite,
  showActualSection,
  viewStoryG,
} from '@/store/actions';
import {
  authSelector,
  collaboratorSelector,
  currentStorySelector,
  extrasSelector,
  intermitenceSelector,
  memorySelector,
  purchaseSelector,
  templatesSelector,
} from '@/store/selectors';
import { canCreateMemory, cdn_url, checkRoleAndPermission } from '@/utils';

import { Box, Fab, Theme, Typography, useMediaQuery, Fade } from '@mui/material';
import { useRouter } from 'next/router';
import Link from 'next/link';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MediaGrid from './MediaGrid';
import EllipseLeftImage from '../../public/images/EllipseLeft';
import EllipseRightImage from '../../public/images/EllipseRight';
import { DividerType, EllipseType, palette } from '@/theme/constants';
import { PrivateStoryModal } from '@/screens/Memories/components/PrivateStoryModal';
import { AddCollaborators } from '@/screens/Memories/components';
import ProfileCard from './StoryHeader';
import { ManageCollaborators } from '@/screens/ManageCollaborators';
import Image from 'next/image';

const Main: React.FC = () => {
  const inviteDispatched = useRef(false);
  const handleBackClick = () => {
    router.push('/app/home');
  };
  const [selectedMemorie, setSelectedMemorie] = useState<any>(null);
  const { status: privateStatus, switchStatus: switchPublication } = UseIntermitence();
  const [adminPalette, setAdminPalette] = useState({
    storyBackgroundColor: '',
    textColor: '',
    accentColor: '',
  });
  const { user, isAuth } = useSelector(authSelector);
  const dispatch = useDispatch();
  const story = useSelector(currentStorySelector);
  const { showPublishModal } = useSelector(intermitenceSelector);
  const { template, actionSuccess } = useSelector(templatesSelector);
  const { approveSuccess } = useSelector(memorySelector);
  const { collaborators, actionSuccessColab, inviteflag, inviteData } = useSelector(collaboratorSelector);
  const [NoColab, SetNoColab] = useState(true);
  const [CloseColab, SetCloseColab] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showLoading, setShowLoading] = useState(true);
  const extras = useSelector(extrasSelector);
  const [viewStory, setViewStory] = useState(false);
  const isMobile = useMediaQuery((template: Theme) => template.breakpoints.down('md'));
  const router = useRouter();
  const { setRedirectTo } = useAuth();
  const [tryCode, setTryCode] = useState(true);
  const [foundRole, setFoundRole] = useState(false);
  const [Invitation, SetInvitation] = useState(false);
  const purchase = useSelector(purchaseSelector);
  useEffect(() => {
    dispatch({ type: 'RESET_APPROVE_SUCCESS' });
  }, [approveSuccess]);

  UseFirstRender(() => {
    if (router.query?.id && !router.query.code) {
      dispatch(
        actualStory({
          id: router.query?.id as string,
          router,
          confirmPassword: story?.url === router.query?.id ? story?.confirmPassword : undefined,
          invitation: String(Invitation),
        }),
      );
    }
  }, [router.query?.id, story?.confirmPassword, approveSuccess]);

  const isCreatorOrOwner =
    user?.id === story?.user_id ||
    user?.roles?.find((role: any) => role.story_id === story?.id && role.role.name === 'Story_Admin') ||
    user?.roles?.find((role: any) => role.story_id === story?.id && role.role.name === 'Story_Collaborator');

  UseFirstRender(() => {
    if (router.query?.id && router.query.code) {
      dispatch(setCode({ password: router?.query?.code, storyId: router.query.id }));
    }
  }, [router.query?.code]);

  const decodeInviteParams = () => {
    const queryParams = new URLSearchParams(window.location.search);

    const storyId = queryParams.get('story_id') ? atob(queryParams.get('story_id')!) : null;
    const referralCode = queryParams.get('referral_code') ? atob(queryParams.get('referral_code')!) : null;
    const userType = queryParams.get('user_type') ? atob(queryParams.get('user_type')!) : null;
    const role = queryParams.get('role') ? atob(queryParams.get('role')!) : null;

    if (!storyId && !referralCode && !userType && !role) return null;

    return { storyId, referralCode, userType, role };
  };

  useEffect(() => {
    if (!router.isReady) return;

    const inviteData = decodeInviteParams();
    if (!inviteData) return;
    SetInvitation(true);
    if (user?.token && !inviteDispatched.current) {
      const { storyId, userType, role } = inviteData;

      if (storyId && role && userType) {
        dispatch(
          inviteAccepted({
            story_id: storyId,
            role_name: role,
            user_type: userType,
          }),
        );
        inviteDispatched.current = true;
      }
    } else if (!user?.token) {
      // router.push('/app/register');
      dispatch(setPendingInvite(inviteData));
      localStorage.setItem('inviteData', JSON.stringify(inviteData));
    }
  }, [router.isReady, user?.token]);

  useEffect(() => {
    if (!user?.token || !story?.id) return;

    const storedInviteData = localStorage.getItem('inviteData');

    if (storedInviteData) {
      const parsedData = JSON.parse(storedInviteData);

      if (parsedData.storyId == story?.id && !inviteDispatched.current) {
        dispatch(
          inviteAccepted({
            story_id: parsedData.storyId,
            role_name: parsedData.role,
            user_type: parsedData.userType,
          }),
        );
      }

      localStorage.removeItem('inviteData');
    }
  }, [user?.token, story?.id]);

  useEffect(() => {
    if (story?.id) {
      if (user?.token) {
        SetNoColab(false);
        dispatch(getCollaboratorStory(story?.id));
        dispatch(getUserPurchases(user.id));
      }

      dispatch({ type: 'RESET_INVITE_ACCEPTED' });
      dispatch(
        actualStory({
          id: router.query?.id as string,
          router,
          confirmPassword: story?.url === router.query?.id ? story?.confirmPassword : undefined,
          invitation: String(Invitation),
        }),
      );
    }
  }, [story?.id, inviteflag, actionSuccess]);

  useEffect(() => {
    if (user?.token && story?.id) dispatch(getCollaboratorStory(story?.id));
    dispatch({ type: 'RESET_INVITE_ACCEPTED' });
  }, [story?.id, dispatch, inviteflag]);

  useEffect(() => {
    if (story?.url === router.query?.id)
      router.push(
        router?.query?.memoryId
          ? `/app/story/${story?.url}?memoryId=${router?.query?.memoryId}`
          : `/app/story/${story?.url}`,
      );
  }, [router.query?.id, story?.url]);

  useEffect(() => {}, [extras?.extraContent]);

  UseFirstRender(() => {
    if (user && isAuth && story?.id) {
      const inviteData = decodeInviteParams();
      if (!inviteData && !router?.query?.code) {
        const validRoles = ['Story_Collaborator', 'Story_Viewer', 'Story_Admin'];
        // console.log("user roles",user?.roles[0]?.role?.name);
        const hasRole = user?.roles?.find(
          (role: any) => role.story_id === story?.id && validRoles.includes(role?.role?.name),
        );
        // console.log("has Role", hasRole)
        // console.log("purchases", purchase?.userPurchases[0])
        const purchasedStory = purchase?.userPurchases?.find(
          (p: any) => Number(p.storyId) === Number(story?.id),
        );
        // console.log("purchasedStory", purchasedStory)
        const userCreate = user?.id === story?.user_id;
        const foundRole = hasRole || purchasedStory || userCreate ? true : false;
        setFoundRole(foundRole);
      }
    }
  }, [user, story, isAuth]);

UseFirstRender(() => {
  const validRoles = ['Story_Collaborator', 'Story_Viewer', 'Story_Admin'];

  const hasRole = user?.roles?.some((r: any) =>
    Number(r.story_id) === Number(story?.id) &&
    validRoles.includes(r.role?.name || r.name)
  );

  const userCreate = Number(user?.id) === Number(story?.user_id);
  const foundRole = hasRole || userCreate;

  const inviteData = decodeInviteParams();

  if (story?.private && tryCode && !story?.newCode && !foundRole && !inviteData) {
    switchPublication();
    setTryCode(false);
  }
}, [story?.private, story?.id, story?.newCode, user?.id, user?.roles, tryCode]);


  useEffect(() => {
    if (story?.id && !viewStory) {
      dispatch(viewStoryG(story));
      setViewStory(true);
    }
  }, [dispatch, story, viewStory]);

  const handlePublication = () => {
    if (story?.private && !tryCode && !story?.confirmPassword) {
      switchPublication();
      router.push(`/app/home`);
    }
    if (story?.private && !tryCode && story?.confirmPassword && !story?.newCode) {
      switchPublication();
    }
  };
  const CloseManageCollaborators = () => [SetCloseColab(!CloseColab)];

  const boxRef = useRef<HTMLElement | null>(null);

  const [mobileHeight, setMobileHeight] = useState('35vh');

  useEffect(() => {
    const resize = () => {
      if ((boxRef?.current?.scrollTop || 0) > 100) {
        setMobileHeight((prev: any) => {
          return `${
            (boxRef?.current?.scrollTop || 0) > 500 ? 0 : Math.round(35 / ((boxRef?.current?.scrollTop || 0) / 100))
          }vh`;
        });
        return;
      }
      setMobileHeight('35vh');
    };
    if (boxRef.current) {
      boxRef.current?.addEventListener('scroll', resize);
    }
    dispatch(changeBackground(true));

    return () => {
      if (boxRef.current) {
        boxRef.current?.removeEventListener('scroll', resize);
      }
    };
  }, [story]);

  const closeCollaboratorsModal = () => {
    dispatch(closePublishModal());
  };
  useEffect(() => {
    if (Number(mobileHeight.replace('vh', '')) <= 10) dispatch(hideGradient(true));
    if (Number(mobileHeight.replace('vh', '')) > 10) dispatch(hideGradient(false));
  }, [mobileHeight]);

  useEffect(() => {
    if (story?.themeId) {
      dispatch(getTemplate(story?.themeId ? story?.themeId : '1'));
    }
  }, [story?.themeId, dispatch, actionSuccess]);
  let backgroundColor: any;
  let accentColor: any;
  useEffect(() => {
    if (template?.template?.colors) {
      const colors = template.template.colors.reduce((acc: any, color: any) => {
        switch (color.PLabel) {
          case 'storyBackground':
            acc.storyBackgroundColor = color.PValue;
            break;
          case 'TextColor':
            acc.textColor = color.PValue;
            break;
          case 'AccentColor':
            acc.accentColor = color.PValue;
            break;
          default:
            break;
        }
        return acc;
      }, {});

      backgroundColor = colors.storyBackgroundColor;
      accentColor = colors.accentColor;
      setAdminPalette({
        storyBackgroundColor: colors.storyBackgroundColor,
        textColor: colors.textColor,
        accentColor: colors.accentColor,
      });
    }
  }, [template]);
  useEffect(() => {
    if (backgroundColor) {
      setTimeout(() => {
        setLoading(true);
      }, 600);
      return () => {};
    }
  }, [template]);

  useEffect(() => {
    const isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().includes('firefox');

    const styleElement = document.createElement('style');

    if (isFirefox) {
      styleElement.innerHTML = `
        html {
          scrollbar-color: ${accentColor} ${accentColor};
          scrollbar-width: thin;
        }
      `;
    } else {
      styleElement.innerHTML = `

        *::-webkit-scrollbar-thumb {

          border-radius: 12px;
        }

      `;
    }

    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  }, [template]);

  const hasCustomTheme = Boolean(adminPalette.storyBackgroundColor);

  const extendedPalette = {
    hasCustomTheme,
    storyBackground: adminPalette.storyBackgroundColor,
    backButton: {
      color: adminPalette.textColor,
      opacity: 0.7,
      fontSize: '14px',
    },
    edittextColor: adminPalette.textColor,
    editButton: {
      color: '#33333',
      opacity: 0.7,
      backgroundColor: adminPalette.accentColor,
      fontSize: '14px',
      textTransform: 'none',
      borderRadius: '9999px',
      boxShadow: '0px 4px 14px 0px #00000029',
      '&:hover': {
        backgroundColor: adminPalette.accentColor,
        opacity: 1,
      },
    },
    storyTitle: adminPalette.textColor,
    dateStyle: {
      color: adminPalette.textColor,
      opacity: 0.7,
      fontSize: '16px',
      textAlign: 'center',
    },
    description: {
      color: adminPalette.textColor,
      maxWidth: '650px',
    },
    toolBarBackground: 'rgba(0, 0, 0, 0.5)',
    searchField: {
      width: '16rem',
      background: 'linear-gradient(174deg, rgba(27, 27, 27, 0.5) -68.72%, rgba(0, 0, 0, 0.5) 269.6%), #333',
      boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.5) inset',
      borderRadius: '16px',
      border: 'none',
      outline: 'none',
    },

    filterButton: (filter: any, label: any) => ({
      textTransform: 'none',
      backgroundColor: filter === label ? adminPalette.textColor : adminPalette.storyBackgroundColor,
      color: filter === label ? palette.black : adminPalette.textColor,
      borderRadius: '20px',
      margin: '8px',
      '&:hover': {
        backgroundColor: filter === label ? adminPalette.textColor : adminPalette.storyBackgroundColor,
        color: filter === label ? palette.black : adminPalette.textColor,
      },
    }),
    dividerColor: {
      color: 'rgba(51, 51, 51, 1)',
      opacity: 0.9,
    },

    viewButton: {
      textTransform: 'none',
      color: palette.dirtyWhite,
      '&:hover': {
        color: palette.secondary,
      },
    },
    buttonbackgroundIcon: adminPalette.accentColor,
    buttonColorGrid: adminPalette.storyBackgroundColor,
    buttonHoverColor: '#BA0C2F',
    cardMediaBackground: {
      background: adminPalette.storyBackgroundColor,
    },
    cardMediaColor: adminPalette.textColor,
    cardHeaderBackground: adminPalette.storyBackgroundColor,
    cardHeaderText: adminPalette.textColor,
    audioGradientColor1: {
      background: 'linear-gradient(45deg, #0072CE, #5DAFFB)',
    },
    audioGradientColor2: adminPalette.accentColor,
    isDividerCheck: { isDivider: false } as DividerType,
    isEllipseCheck: { isEllipseLeft: true } as EllipseType,
    isEllipseRightCheck: { isEllipseRight: true } as EllipseType,
    ellipseLeftGradientColor: adminPalette.accentColor,
    ellipseLeftGradientOpacity: 0.17,
    ellipseRightGradientColor: '#F1E0FF',
    ellipseRightGradientOpacity: 0.2,
    cardIconColor: '#B3BED4',
    filterIconsColor: 'rgba(102, 102, 102, 1)',
    filterIconsSelectedColor: 'rgba(191, 87, 0)',
    filterIconsHoverColor: adminPalette.accentColor,
  };

  const useBodyBackground = (color: string = '#fff') => {
    useEffect(() => {
      document.body.style.background = color;

      return () => {
        document.body.style.background = '';
      };
    }, [color]);
  };
  useBodyBackground(palette?.background);

  const hasLoaded = actionSuccess && story && extendedPalette && adminPalette && loading;

  useEffect(() => {
    if (hasLoaded) {
      // Wait for fade transition to complete before hiding
      const timer = setTimeout(() => {
        setShowLoading(false);
      }, 750);
      return () => clearTimeout(timer);
    } else {
      setShowLoading(true);
    }
  }, [hasLoaded]);

  const goToCreateMemory = () => {
    if (!user?.token) {
      if (story?.url) {
        setRedirectTo(`/app/story/${story.url}/memory/create`);
      }
      router.push('/app/register');
      return;
    }

    dispatch(refreshUserData());

    if (story?.user_id === user?.id) {
      if (
        !checkRoleAndPermission(story?.user?.roles, 'Subscriber_Individual', 'CLIENT_MEMORY_UPDATE', story?.user_id)
      ) {
        localStorage.setItem('router_history', `/app/story/${story?.url}`);
        setTimeout(() => {
          dispatch(openSubscriptionPopup());
        }, 2000);
        return;
      }
    }
    router.push(`/app/story/${story?.url}/memory/create`);
    dispatch(setCreateMemoryStep(1));
    dispatch(showActualSection('create_new_memory'));
  };

  const scrollContainerRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <Box
        ref={scrollContainerRef}
        sx={{
          width: '100%',
          height: isMobile ? 'auto' : '100vh',
          minHeight: isMobile ? '100vh' : 'auto',
          position: 'relative',
          overflow: isMobile ? 'visible' : 'auto',
          // Use theme background color if custom theme exists, otherwise use default image
          backgroundColor: hasCustomTheme ? extendedPalette.storyBackground : undefined,
          backgroundImage: hasCustomTheme
            ? 'none'
            : !isMobile
            ? 'url(/images/bg-main.jpg)'
            : story?.cover_image
            ? 'transparent'
            : 'url(/images/bg-main.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'bottom center',
        }}>
        {/* Background layer - uses theme color (if custom) or blurred cover image on mobile */}
        {isMobile && (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              position: 'fixed',
              top: 0,
              left: 0,
              backgroundImage: story?.cover_image && !hasCustomTheme ? `url('${cdn_url}${story.cover_image}')` : 'none',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              opacity: '0.9',
              backgroundRepeat: 'no-repeat',
              filter: story?.cover_image && !hasCustomTheme ? 'blur(40px)' : 'none',
              backgroundColor: hasCustomTheme ? extendedPalette.storyBackground : (!story?.cover_image ? extendedPalette.storyBackground : 'transparent'),
              pointerEvents: 'none',
            }}
          />
        )}
        {hasLoaded && (
          <Box
            sx={{
              minHeight: isMobile ? 'auto' : '100vh',
              maxHeight: isMobile ? 'none' : '100vh',
              backgroundColor: 'transparent',
              padding: router?.pathname == '/app/story/[id]' && !isMobile ? '0px 0px' : '0px',
              touchAction: isMobile ? 'pan-y' : 'auto',
            }}>
            {extendedPalette.isEllipseCheck.isEllipseLeft && (
              <Box
                sx={{
                  position: 'fixed',
                  left: '0%',
                  top: '0%',
                  zIndex: 0,
                  width: '80rem',

                  pointerEvents: 'none',
                  backgroundRepeat: 'no-repeat, no-repeat',
                  backgroundSize: 'contain, contain',
                }}>
                <EllipseLeftImage
                  color={extendedPalette.ellipseLeftGradientColor}
                  opacity={extendedPalette.ellipseLeftGradientOpacity}
                />
              </Box>
            )}

            {/* Ellipse 2 (Right Center) */}
            {extendedPalette.isEllipseRightCheck.isEllipseRight && (
              <Box
                sx={{
                  position: 'fixed',
                  right: isMobile ? '-4%' : '-20%',
                  top: isMobile ? '8%' : '12%',
                  zIndex: 0,
                  width: '60%',
                  backgroundRepeat: 'no-repeat, no-repeat',
                  pointerEvents: 'none',
                }}>
                <EllipseRightImage
                  color={extendedPalette.ellipseRightGradientColor}
                  opacity={extendedPalette.ellipseRightGradientOpacity}
                />
              </Box>
            )}
            <ProfileCard
              extendedPalette={extendedPalette}
              profileSrc={story?.cover_image ? `${cdn_url}${story.cover_image}` : ''}
              coverSrc={story?.cover_image ? `${cdn_url}${story.cover_image}` : ''}
              title={story?.title}
              story={story}
              CloseManageCollaborators={CloseManageCollaborators}
              description={story?.description}
              createdDate={story?.created_at}
              collaborators={story?.collaborators}
            />
            {/* <GridLayoutCheck /> */}
            <MediaGrid
              invitation={Invitation}
              NoColab={NoColab}
              actionSuccessColab={actionSuccessColab}
              extendedPalette={extendedPalette}
              story={story && story}
              scrollContainerRef={scrollContainerRef}
            />
            {/* {!isMobile && (

          )} */}
            {!foundRole && !story?.confirmPassword && story?.private && story.url === router.query?.id && (
              <PrivateStoryModal open={privateStatus} onClose={handlePublication} />
            )}
            <AddCollaborators
              CloseManageCollaborators={CloseManageCollaborators}
              extendedPalette={extendedPalette}
              add={showPublishModal}
              onClose={() => closeCollaboratorsModal()}
              mediaContent={selectedMemorie}
              method={() => closeCollaboratorsModal()}
            />
            <ManageCollaborators
              extendedPalette={extendedPalette}
              add={CloseColab}
              onClose={() => CloseManageCollaborators()}
              mediaContent={selectedMemorie}
              method={() => closeCollaboratorsModal()}
            />
            {(canCreateMemory(Invitation, story?.private) || isCreatorOrOwner || !user?.token) && (
              <Fab
                size={isMobile ? 'medium' : 'large'}
                onClick={goToCreateMemory}
                sx={{
                  width: '3.6rem',
                  height: '3.6rem',
                  display: 'flex',
                  backgroundColor: palette?.white,
                  gap: '1rem',
                  borderRadius: '100px',
                  position: 'fixed',
                  right: { xs: '0.75rem', md: '2.5rem', lg: '2.5rem', xl: '22.5rem' },
                  bottom: { xs: '7rem', md: '2.5rem' },
                  boxShadow: '0px 8px 30px 0px rgba(33, 45, 109, 0.12)',
                }}>
                <Image
                  priority
                  src={`/icons/add.svg`}
                  width={isMobile ? 36 : 26}
                  height={isMobile ? 36 : 26}
                  quality={80}
                  alt='add memory'
                />
              </Fab>
            )}
          </Box>
        )}
        {showLoading && (
          <Fade in={!hasLoaded} timeout={750}>
            <Box
              width={'100%'}
              height={'100vh'}
              display={'flex'}
              justifyContent={'center'}
              alignItems={'center'}
              sx={{
                position: hasLoaded ? 'absolute' : 'fixed',
                top: 0,
                left: 0,
              }}>
              <Image src='/images/Loading.svg' quality={'100'} alt='loading' fill style={{ objectFit: 'cover' }} />
            </Box>
          </Fade>
        )}
      </Box>
    </>
  );
};

export default Main;
